import { lazy } from 'react';
import { retry } from '../../../config/utils';

const LenderAddress = lazy(() => retry(()=> import(/* webpackChunkName: "LenderAddress" */ "./Address")));

export default LenderAddress;